import React from 'react'
import styled from 'styled-components'

const ErrorTemplate = styled.div`
  padding: 40px 15px;
  text-align: center;
`

function NotFound() {
  return (
    <div id="404" className="container">
      <div className="row">
        <div className="col-md-12">
          <ErrorTemplate>
            <h1>Oops</h1>
            <h2>404 Not Found</h2>
            <div className="error-details">
              Sorry, an error has occurred! Requested page not found.
            </div>
          </ErrorTemplate>
        </div>
      </div>
    </div>
  )
}

export default NotFound
